/**
 * Acoustic Isolation Co. storefront helpers
 * - Blocks Prop 65 products from California checkout
 */
(function () {
  'use strict';

  var PROP65_VARIANT_IDS = (window.AIC && window.AIC.prop65VariantIds) || [];
  var PROP65_SET = {};
  for (var i = 0; i < PROP65_VARIANT_IDS.length; i++) {
    PROP65_SET[String(PROP65_VARIANT_IDS[i])] = true;
  }

  function isCalifornia(value) {
    if (!value) return false;
    var v = String(value).trim().toUpperCase();
    return v === 'CA' || v === 'CALIFORNIA' || v === 'CALIF.' || v === 'CALIF';
  }

  function cartHasProp65(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var id = String(item.variant_id || item.id || '');
      if (PROP65_SET[id]) return true;
      // Line item property set on product add
      if (item.properties) {
        if (item.properties._ca_restricted === 'yes' || item.properties['California restricted'] === 'Yes') {
          return true;
        }
      }
    }
    return false;
  }

  function getShipState(cart) {
    if (!cart || !cart.attributes) return '';
    return (
      cart.attributes.ship_to_state ||
      cart.attributes.shipping_state ||
      cart.attributes['Ship to state'] ||
      ''
    );
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (r) {
        return r.json();
      }
    );
  }

  function updateCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (r) {
      return r.json();
    });
  }

  function showBlockMessage(el, message) {
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
  }

  function hideBlockMessage(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  var BLOCK_MSG =
    'These products cannot be sold or shipped to California residents. Remove Prop 65 items from your cart, or choose a non-California shipping state to continue.';

  /**
   * Cart page: require ship-to state; block checkout for CA + Prop 65
   */
  function initCartCaGate() {
    var root = document.getElementById('aic-ca-gate');
    if (!root) return;

    var hasProp65 = root.getAttribute('data-has-prop65') === 'true';
    var stateSelect = document.getElementById('aic-ship-state');
    var checkoutBtn = document.getElementById('aic-checkout-btn');
    var msg = document.getElementById('aic-ca-block-msg');
    var form = root.closest('form') || document.getElementById('aic-cart-form');

    if (!hasProp65) {
      if (checkoutBtn) checkoutBtn.disabled = false;
      return;
    }

    function evaluate() {
      var state = stateSelect ? stateSelect.value : '';
      var blocked = isCalifornia(state);

      if (!state) {
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
          checkoutBtn.setAttribute('aria-disabled', 'true');
        }
        hideBlockMessage(msg);
        if (msg) {
          msg.hidden = false;
          msg.textContent = 'Select your shipping state before checkout. Prop 65 products cannot ship to California.';
          msg.className =
            'mt-3 p-3 rounded-xl border border-slate-300 bg-slate-50 text-slate-700 text-sm leading-relaxed';
        }
        return { ok: false, reason: 'need-state' };
      }

      if (blocked) {
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
          checkoutBtn.setAttribute('aria-disabled', 'true');
        }
        if (msg) {
          msg.className =
            'mt-3 p-3 rounded-xl border border-red-300 bg-red-50 text-red-950 text-sm leading-relaxed font-medium';
        }
        showBlockMessage(msg, BLOCK_MSG);
        return { ok: false, reason: 'ca-blocked' };
      }

      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        checkoutBtn.removeAttribute('aria-disabled');
      }
      hideBlockMessage(msg);
      return { ok: true, state: state };
    }

    if (stateSelect) {
      stateSelect.addEventListener('change', function () {
        var state = stateSelect.value;
        updateCartAttributes({
          ship_to_state: state,
          ca_sales_ack: isCalifornia(state) ? 'blocked' : 'ok',
        }).catch(function () {});
        evaluate();
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // Allow quantity update without state
        var submitter = e.submitter;
        var name = submitter && submitter.getAttribute('name');
        if (name === 'update') return;

        if (name === 'checkout' || (submitter && submitter.id === 'aic-checkout-btn')) {
          var result = evaluate();
          if (!result.ok) {
            e.preventDefault();
            e.stopPropagation();
            if (stateSelect) stateSelect.focus();
            return false;
          }
          // Persist state then allow native checkout submit
        }
      });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        var result = evaluate();
        if (!result.ok) {
          e.preventDefault();
          e.stopPropagation();
          if (stateSelect) stateSelect.focus();
          return false;
        }
      });
    }

    // Initial state from attribute if present
    evaluate();
  }

  /**
   * Global: intercept direct /checkout navigations when cart has Prop 65
   * and ship_to_state is CA (or missing — force back to cart to declare state).
   */
  function initGlobalCheckoutGuard() {
    if (!PROP65_VARIANT_IDS.length) return;

    function guardCheckout(e, href) {
      if (!href) return;
      try {
        var url = new URL(href, window.location.origin);
        if (url.pathname !== '/checkout' && url.pathname.indexOf('/checkouts/') !== 0) return;
      } catch (err) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      fetchCart()
        .then(function (cart) {
          if (!cartHasProp65(cart)) {
            window.location.href = '/checkout';
            return;
          }
          var state = getShipState(cart);
          if (isCalifornia(state)) {
            window.location.href = '/cart?ca_blocked=1';
            return;
          }
          if (!state) {
            // Force cart so customer declares shipping state before checkout
            window.location.href = '/cart?declare_state=1';
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    }

    document.addEventListener(
      'click',
      function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a) return;
        guardCheckout(e, a.getAttribute('href'));
      },
      true
    );

    // Intercept form posts to /cart that request checkout
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.action) return;
        var action = form.getAttribute('action') || '';
        var hasCheckout =
          (form.querySelector('[name="checkout"]') && e.submitter && e.submitter.name === 'checkout') ||
          (e.submitter && e.submitter.id === 'aic-checkout-btn');
        if (!hasCheckout) return;
        // Cart page has its own handler
        if (document.getElementById('aic-ca-gate')) return;

        // Other forms going to checkout
        if (action.indexOf('/cart') !== -1 || action.indexOf('checkout') !== -1) {
          // let cart page handle; global only for non-gate forms
        }
      },
      true
    );
  }

  /**
   * Product page: ensure Prop 65 add-to-cart includes restriction property
   */
  function initProductCaProperty() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (form.getAttribute('data-prop65') !== 'true') return;
      if (!form.querySelector('input[name="properties[_ca_restricted]"]')) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_ca_restricted]';
        input.value = 'yes';
        form.appendChild(input);
      }
      if (!form.querySelector('input[name="properties[California restricted]"]')) {
        var input2 = document.createElement('input');
        input2.type = 'hidden';
        input2.name = 'properties[California restricted]';
        input2.value = 'Yes — not sold to CA residents';
        form.appendChild(input2);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartCaGate();
    initGlobalCheckoutGuard();
    initProductCaProperty();

    // Surface query-string block messages on cart
    var params = new URLSearchParams(window.location.search);
    if (params.get('ca_blocked') === '1') {
      var msg = document.getElementById('aic-ca-block-msg');
      if (msg) {
        msg.className =
          'mt-3 p-3 rounded-xl border border-red-300 bg-red-50 text-red-950 text-sm leading-relaxed font-medium';
        showBlockMessage(msg, BLOCK_MSG);
      }
    }
    if (params.get('declare_state') === '1') {
      var sel = document.getElementById('aic-ship-state');
      if (sel) sel.focus();
    }
  });
})();
